import { useTranslation } from 'react-i18next'

import { InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import useCreatePreview from './useCreatePreview/useCreatePreview'
import { buttonContainerId, previewScriptContainerId } from './constants'
import * as Styles from './styles'

const WidgetPreview = ({
  backgroundColor,
  textColor,
  buttonColor,
  buttonHoverColor,
  previewProduct,
  storeId,
  tryonMode,
}) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  useCreatePreview({
    backgroundColor,
    textColor,
    buttonColor,
    buttonHoverColor,
    language: i18n.language,
    productId: previewProduct?.product_id,
    storeId,
    tryonMode,
  })

  return (
    <Styles.PreviewContainer>
      <Text type="titleS">{t('Vista previa')}</Text>
      <Styles.Preview>
        <Styles.PreviewContent>
          <Styles.InfoMessage>
            <InfoIcon size={24} color={theme.colors.info.hover} />
            <Text type="bodySRegular" color={theme.colors.info.hover}>
              {t("Haz clic en el botón 'Try on' para iniciar el flujo.")}
            </Text>
          </Styles.InfoMessage>
          <Styles.ProductWidgetWrapper>
            {previewProduct?.product_image_url && (
              <Styles.ProductImageContainer id={buttonContainerId}>
                <Styles.ProductImage src={previewProduct.product_image_url} alt={previewProduct.product_name} />
              </Styles.ProductImageContainer>
            )}
            <Styles.WidgetScriptContainer id={previewScriptContainerId} />
          </Styles.ProductWidgetWrapper>
        </Styles.PreviewContent>
      </Styles.Preview>
    </Styles.PreviewContainer>
  )
}

export default WidgetPreview
